import { ICreateRestaurantState } from './createRestaurantContext';
import { CreateRestaurantActionTypes, TCreateRestaurantAction } from './createRestaurantActions';

export const createRestaurantReducer = (
	state: ICreateRestaurantState,
	action: TCreateRestaurantAction,
): ICreateRestaurantState => {
	switch (action.type) {
		case CreateRestaurantActionTypes.SET_FETCHED_COUNTRIES:
			return {
				...state,
				fetchedCountries: action.payload.fetchedCountries,
			};
		case CreateRestaurantActionTypes.SET_ID_COUNTRY:
			return {
				...state,
				IDSelectedCountry: action.payload.IDSelectedCountry,
				fetchedCities: [],
				IDSelectedCity: null,
			};
		case CreateRestaurantActionTypes.SET_FETCHED_CITIES:
			return {
				...state,
				fetchedCities: action.payload.fetchedCities,
			};
		case CreateRestaurantActionTypes.SET_ID_CITY:
			return {
				...state,
				IDSelectedCity: action.payload.IDSelectedCity,
			};
		case CreateRestaurantActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case CreateRestaurantActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				isUsedCustomerPriceType: action.payload.isUsedCustomerPriceType,
				fetchedLanguages: [],
				IDSelectedDefaultLanguage: null,
			};
		case CreateRestaurantActionTypes.SET_CLIENT_TYPE:
			return {
				...state,
				clientType: action.payload.clientType,
			};
		case CreateRestaurantActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateRestaurantActionTypes.SET_FETCHED_CURRENCIES:
			return {
				...state,
				fetchedCurrencies: action.payload.fetchedCurrencies,
			};
		case CreateRestaurantActionTypes.SET_CURRENCY_SYMBOL:
			return {
				...state,
				selectedCurrencySymbol: action.payload.selectedCurrencySymbol,
			};
		case CreateRestaurantActionTypes.CHANGE_ADDRESS:
			return {
				...state,
				address: action.payload.address,
			};
		case CreateRestaurantActionTypes.CHANGE_EMAIL:
			return {
				...state,
				email: action.payload.email,
			};
		case CreateRestaurantActionTypes.CHANGE_CODE:
			return {
				...state,
				code: action.payload.code,
			};
		case CreateRestaurantActionTypes.CHANGE_PRICE_TYPE:
			return {
				...state,
				priceType: action.payload.priceType,
			};
		case CreateRestaurantActionTypes.TOGGLE_IS_USED_CUSTOMER_PRICE_TYPE:
			return {
				...state,
				isUsedCustomerPriceType: action.payload.isUsedCustomerPriceType,
				priceType: action.payload.priceType,
			};
		case CreateRestaurantActionTypes.SET_ID_POS_SYSTEM:
			return {
				...state,
				IDPosSystem: action.payload.IDPosSystem,
			};
		case CreateRestaurantActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.fetchedLanguages,
			};
		case CreateRestaurantActionTypes.SET_ID_DEFAULT_LANGUAGE:
			return {
				...state,
				IDSelectedDefaultLanguage: action.payload.IDSelectedDefaultLanguage,
			};
		case CreateRestaurantActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateRestaurantActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateRestaurantActionTypes.RESET_FIELDS:
			return {
				...state,
				fetchedCountries: [],
				IDSelectedCountry: null,
				fetchedCities: [],
				IDSelectedCity: null,
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				clientType: null,
				name: '',
				fetchedCurrencies: [],
				selectedCurrencySymbol: null,
				address: '',
				email: '',
				code: '',
				priceType: null,
				isUsedCustomerPriceType: false,
				IDPosSystem: null,
				fetchedLanguages: [],
				IDSelectedDefaultLanguage: null,
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
